import { render } from "./TeamingButton2.vue?vue&type=template&id=66b1903c&scoped=true"
import script from "./TeamingButton2.vue?vue&type=script&lang=js"
export * from "./TeamingButton2.vue?vue&type=script&lang=js"

import "./TeamingButton2.vue?vue&type=style&index=0&id=66b1903c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66b1903c"

export default script